



import { Component, Vue } from 'vue-property-decorator';
import Meet from '../../assets/meet.svg?inline';
@Component({
  components: {
    Meet,
  },
})
export default class MeetIcon extends Vue {}
